var map = {
	"./bn.json": "8782",
	"./en.json": "edd4",
	"./fr.json": "f693",
	"./ko.json": "dd11",
	"./pt-BR.json": "03bd",
	"./tr.json": "ffeb",
	"./zh-CN.json": "423e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";